import {
  LEGACY_ACCOUNT_SECTION_ROUTE,
  LEGACY_MY_ACCOUNT_PAGES,
} from 'constants/links';
import { normalizeCommerceLink } from 'utils/links';
import { getRelativeURLWithParams } from 'utils/url';

export const getOrderHistoryLink = (
  storeId: string,
  langId: string,
  catalogId: string
) => {
  return normalizeCommerceLink(
    getRelativeURLWithParams(LEGACY_ACCOUNT_SECTION_ROUTE, {
      showOrderHeader: false,
      route: LEGACY_MY_ACCOUNT_PAGES.ORDERS,
      storeId,
      langId,
      catalogId,
      orderStatusStyle: 'strong',
    })
  );
};

export const getControlCenterLink = (
  storeId: string,
  langId: string,
  catalogId: string
) => {
  return normalizeCommerceLink(
    getRelativeURLWithParams(LEGACY_ACCOUNT_SECTION_ROUTE, {
      storeId,
      langId,
      catalogId,
      route: LEGACY_MY_ACCOUNT_PAGES.CONTROL_CENTER,
    })
  );
};
